import { render, staticRenderFns } from "./UploadSelect.vue?vue&type=template&id=72434134&scoped=true"
import script from "./UploadSelect.vue?vue&type=script&lang=js"
export * from "./UploadSelect.vue?vue&type=script&lang=js"
import style0 from "./UploadSelect.vue?vue&type=style&index=0&id=72434134&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72434134",
  null
  
)

export default component.exports